import { render, staticRenderFns } from "./PageSummary.vue?vue&type=template&id=3c85c8e6"
import script from "./PageSummary.vue?vue&type=script&lang=js"
export * from "./PageSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports